import React from 'react';

function InfoBoxImg (props) {
	return (
		<div></div>
	);
}

export default InfoBoxImg;